import React, { memo } from "react";
import NodeWrapper from "./NodeWrapper";
import { EmojiEmotions } from "@mui/icons-material";

/**
 * Send Sticker — Enviar sticker/figurinha.
 *
 * data.stickerUrl: string — URL do sticker (WebP)
 * data.stickerName: string — nome/label do sticker (opcional)
 *
 * Saida: handle "a" (default)
 */
const SendStickerNode = memo(({ id, data, isConnectable, selected }) => {
  const url = data?.stickerUrl || "";
  const name = data?.stickerName || "";

  return (
    <NodeWrapper
      id={id}
      data={data}
      icon={<EmojiEmotions />}
      title="Enviar Sticker"
      color="#6D4C41"
      bgColor="#EFEBE9"
      isConnectable={isConnectable}
      selected={selected}
      minWidth={180}
    >
      <div style={{
        display: "flex", alignItems: "center", gap: 8,
        background: "#fff", border: "1px solid #e0e0e0",
        borderRadius: 6, padding: "6px 10px",
      }}>
        {url ? (
          <img
            src={url}
            alt="sticker"
            style={{
              width: 40, height: 40,
              objectFit: "contain",
              borderRadius: 4,
            }}
            onError={(e) => { e.target.style.display = "none"; }}
          />
        ) : (
          <EmojiEmotions style={{ fontSize: 32, color: "#BCAAA4" }} />
        )}
        <span style={{ fontSize: 11, color: "#5D4037", fontWeight: 500 }}>
          {name || (url ? "Sticker" : "Nao configurado")}
        </span>
      </div>
    </NodeWrapper>
  );
});

SendStickerNode.displayName = "SendStickerNode";
export default SendStickerNode;
